import React from 'react';
import { createRoot } from 'react-dom/client';

import DatasetRequestApp from './containers/DatasetRequestApp';

import '~/scss/pages/dataset_request.scss';

createRoot(document.getElementById('dataset-request-app')).render(
    <DatasetRequestApp datasetRequestApiEndpoint = { DATASET_REQUEST_API_ENDPOINT } />
);
